import {CatalogStore} from './'

export class CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore) {
  }

  get isGlobalStore() {
    return this.catalog.isGlobalStore
  }

  get queryClient() { return this.stores.queryClient}
  get strings() { return this.stores.strings}
  get groupBy() { return this.catalog.groupBy}

  // get searcher() { return this.catalog.searcher}
  get authStore() { return this.stores.authStore}

  get reports() { return this.stores.reports}
  get contextMenu() { return this.stores.contextMenu}

  get flexLayout() { return this.stores.flexLayout}

  get es() { return this.stores.es}

  get site() { return this.stores.site}

  get stores() { return this.catalog.stores}

  get flexLayoutCatalogRoot() { return this.stores.flexLayoutCatalogRoot}

  get dragDrop() { return this.stores.dragDrop}

  get syncProgress() {
    return this.catalog.stores.syncProgress
  }

  get sidebar() {
    return this.stores.sidebar
  }

  get apollo() {
    return this.stores.apollo
  }

  get vlp() { return this.catalog.vlp}

  get workspaces() { return this.catalog.workspaces}

  get dialogs() { return this.catalog.dialogs}
  get c8() { return this.catalog.c8}

}



// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogInstanceChildStore.ts